import { createStore, applyMiddleware } from 'redux';
import userSettingsReducer from '../reducers/userSettingsReducer';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';

const configureStore = (railsProps) => (
  createStore(userSettingsReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
